import { useQuery } from '@tanstack/react-query';
import API from '../../../../context/API';
import { SoldOutOption } from '../types';
import { QUERY_KEYS } from '../constants';

interface SoldOutOptionsPage {
  options: SoldOutOption[];
  total: number;
}

function sortByUpdatedAt(data: SoldOutOption[]): SoldOutOption[] {
  return [...data].sort(
    (a, b) => new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime()
  );
}

// TODO: re-add `search` to the query string once backend support for it is confirmed on /options/stock.
async function fetchSoldOutOptions(page: number, limit: number): Promise<SoldOutOptionsPage> {
  const response = await API.get(`options/stock?type=Out Of Stock&page=${page}&limit=${limit}`);
  const options = sortByUpdatedAt(response.data.data?.result || []);
  return { options, total: response.data.data?.total ?? 0 };
}

export function useSoldOutOptionsQuery(page: number, pageSize: number, enabled = true) {
  return useQuery({
    queryKey: [QUERY_KEYS.SOLD_OUT_OPTIONS, page, pageSize],
    queryFn: () => fetchSoldOutOptions(page, pageSize),
    staleTime: 0,
    placeholderData: (prev) => prev,
    enabled,
  });
}
